import { state } from './state';
import { getters } from './getters';
import { mutation } from './mutations';
export const layout = {
    namespaced: true,
    state,
    getters,
    mutations: mutation
};
